import { createElement } from 'react';
import { Menu as OriginalMenu, ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
import 'antd/dist/antd.variable.min.css';
import '../../variables.scss';
const { Item: OriginalItem, ItemGroup: OriginalItemGroup, SubMenu: OriginalSubMenu, Divider: OriginalDivider, } = OriginalMenu;
const Menu = (props) => {
    ConfigProvider.config({
        theme: {
            primaryColor: '#f16622',
        },
    });
    const { children, openKeys, subMenuCloseDelay, subMenuOpenDelay, ...resetProps } = props;
    return (createElement(ConfigProvider, { locale: localStorage.getItem('umi_locale') !== 'en-US' ? zhCN : enUS },
        createElement(OriginalMenu, { ...resetProps, openKeys: openKeys?.length > 0 ? openKeys : undefined, subMenuCloseDelay: subMenuCloseDelay > 0 ? subMenuCloseDelay : undefined, subMenuOpenDelay: subMenuOpenDelay > 0 ? subMenuOpenDelay : undefined })));
};
Menu.Item = OriginalItem;
Menu.ItemGroup = OriginalItemGroup;
Menu.SubMenu = OriginalSubMenu;
Menu.Divider = OriginalDivider;
export default Menu;
